export default __webpack_public_path__ + "static/media/P545_B_BD.f91a9a06.pdf";